<div class="landing" [ngClass]="{ 'extra-space': !isInfoBannerDismissed }">
  <app-header
    (bannerDismissed)="handleCloseInfoBanner()"
    [isInfoBannerDismissed]="isInfoBannerDismissed"
  ></app-header>

  <main class="main">
    <router-outlet></router-outlet>
  </main>
  @if (isFuturesRoute()) {
    <app-futures-footer />
  } @else {
    <app-footer></app-footer>
  }
</div>

@if (globalLoaderState | async) {
  <div class="c-global-loader-wrapper">
    <app-loader />
  </div>
}
